import type { ReactNode } from "react";
import { CheckboxInput } from "./CheckboxInput.js";
import { cn } from "@rosette/ts/src/util/cn.js";


interface CheckboxAndLabelProps {
    children: ReactNode;
    className?: string;
    id: string;
    name?: string;
    checked: boolean;
    setChecked: (checked: boolean) => void;
    disabled?: boolean;
    noMargins?: boolean;
}


export function CheckboxAndLabel({
    children, className, id, name, checked, setChecked, disabled, noMargins,
}: CheckboxAndLabelProps) {
    return (
        <div className={cn(
            "flex flex-row items-center",
            noMargins ? null : "my-4",
            className ?? null,
        )}>
            <CheckboxInput
                id={id}
                name={name}
                checked={checked}
                setChecked={setChecked}
                disabled={disabled} />

            <label
                className={cn(
                    "ml-3 flex flex-row items-center text-base",
                    disabled ? "cursor-auto text-subtle" : "cursor-pointer text-strong",
                )}
                htmlFor={name}>

                {children}
            </label>
        </div>
    );
}
